<template>
  <div>
    <header class="site-header">
      <div class="wrapper site-header__wrapper">
        <div class="site-header__start">
          <router-link class="brand" to="/">UFOOD</router-link>
        </div>

        <div class="site-header__end">
          <nav class="nav">
            <button class="nav__toggle" aria-expanded="false" type="button">
              menu
            </button>
            <div v-if="logged">
              <ul class="nav__wrapper">
                <li  class="nav__item"><a href="#/user">{{this.user_name}}</a></li>
                <li @click="logout" class="nav__item"> <router-link to="/"> Log out</router-link>
                  </li>
              </ul>
            </div>
            <div v-else>
              <ul class="nav__wrapper">
                <li @click="signin" class="nav__item"><a href="#">Sign in</a></li>
                <li @click="signup" class="nav__item"><a href="#">Sign up</a></li>
              </ul>
            </div>

          </nav>
          <div class="search">
            <button class="search__toggle"  aria-label="Open search">
              <img  src="@/assets/images/search.svg">
            </button>
            <form class="search__form" action="">
              <input
                type="search"
                name=""
                id="search"
                placeholder="What's on your mind?"
              />
            </form>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },

  props :['user_name', 'logged'],

  methods: {
    logout(){
      this.$emit('logOut')
    },
    signup(){
      this.$router.push('/signup')
    },
    signin(){
      this.$router.push('/login')
    }
  },

  mounted() {
    let navToggle = document.querySelector(".nav__toggle");
    let navWrapper = document.querySelector(".nav__wrapper");

    navToggle.addEventListener("click", function () {
      if (navWrapper.classList.contains("active")) {
        this.setAttribute("aria-expanded", "false");
        this.setAttribute("aria-label", "menu");
        navWrapper.classList.remove("active");
      } else {
        navWrapper.classList.add("active");
        this.setAttribute("aria-label", "close menu");
        this.setAttribute("aria-expanded", "true");
        searchForm.classList.remove("active");
      }
    });

    let searchToggle = document.querySelector(".search__toggle");
    let searchForm = document.querySelector(".search__form");

    searchToggle.addEventListener("click", showSearch);

    function showSearch() {
      searchForm.classList.toggle("active");
      navToggle.setAttribute("aria-expanded", "false");
      navToggle.setAttribute("aria-label", "menu");
      navWrapper.classList.remove("active");
    }

  }
}

</script>

<style scoped>


.brand {
  font-weight: bold;
  font-size: 20px;
  margin-left: 1vw;
  color: black;
}


.site-header {
  position: relative;
  background-color: #def7ff;
}

.site-header__end {
  display: flex;
  align-items: center;
}

.site-header__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

@media (min-width: 800px) {
  .site-header__wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }
}

@media (min-width: 800px) {
  .nav__wrapper {
    display: flex;
  }
}

@media (max-width: 799px) {
  .nav__wrapper {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    z-index: -1;
    background-color: #d9f0f7;
    visibility: hidden;
    opacity: 0;
    transform: translateY(-100%);
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  }

  .nav__wrapper.active {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
}

.nav__item a {
  display: block;
  padding: 1.5rem 1rem;
  color: black;

}

.nav__toggle {
  display: none;
}

@media (max-width: 799px) {
  .nav__toggle {
    display: block;
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
}

.search {
  display: flex;
}

.search__toggle {
  appearance: none;
  order: 1;
  font-size: 0;
  width: 34px;
  height: 34px;
  border: 0;
}

@media (min-width: 800px) {
  .search__toggle {
    outline: none;
    border-left: 1px solid #979797;
    padding-left: 10px;
  }
}

@media (max-width: 799px) {
  .search__toggle {
    position: absolute;
    right: 5.5rem;
    top: 0.65rem;
  }
}

.search__form {
  display: none;
}

.search__form.active {
  display: block;
}

@media (max-width: 799px) {
  .search__form {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
  }

  .search__form input {
    width: 100%;
  }
}

.search__form input {
  min-width: 200px;
  appearance: none;
  border: 0;
  background-color: #fff;
  border-radius: 0;
  font-size: 16px;
  padding: 0.5rem;
}

@media (max-width: 799px) {
  .search__form input {
    border-bottom: 1px solid #979797;
  }
}
.site-header{
  z-index: 999;
}
.titleStyle{
  text-align: center;
  color: black;
  font-style:italic;

}

</style>
